export enum ReportBookType {
  STORY = 'STORY',
  EBOOK = 'EBOOK',
}
